import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import RouterView from "@/views/utils/RouterView.vue"

import LoginView from '../views/LoginView.vue'
import SignUpView from '../views/SignUpView.vue'

import ClientLayoutView from '../views/client/LayoutView.vue'
import ClientHomeView from '../views/client/HomeView.vue'

import ProjectsView from "@/views/client/projects/ProjectsIndexView.vue";
import ProjectCreateView from "@/views/client/projects/ProjectCreateView.vue";
import ProjectEditView from "@/views/client/projects/ProjectEditView.vue";

import MeetingsView from "@/views/client/meetings/MeetingsView.vue";
import SettingsView from "@/views/client/SettingsView.vue";

import { useCookies } from "@vueuse/integrations/useCookies";

const cookies = useCookies(['token']);

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/sign-up',
    name: 'sign-up',
    component: SignUpView,
    meta: {
      title: 'Sign up'
    }
  },
  {
    path: '/client',
    name: 'client',
    component: ClientLayoutView,
    children: [
      {
        path: 'home',
        name: 'client-home',
        component: ClientHomeView,
        meta: {
          title: 'Home'
        }
      },
      {
        path: '/meetings',
        name: 'meetings',
        component: MeetingsView,
        meta: {
          title: 'Meetings'
        }
      },
      {
        path: 'projects',
        name: 'client-projects',
        component: RouterView,
        children: [
          {
            path: 'index',
            name: 'client-projects-index',
            component: ProjectsView,
            meta: {
              title: 'Projects'
            }
          },
          {
            path: ':id/edit',
            name: 'client-project-edit',
            component: ProjectEditView,
            meta: {
              title: 'Project edit'
            }
          },
          {
            path: 'create',
            name: 'client-project-create',
            component: ProjectCreateView,
            meta: {
              title: 'Project create'
            }
          },
        ]
      },
      {
        path: '/settings',
        name: 'settings',
        component: SettingsView
      },
    ],
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `Augmentify | ${to.meta.title ?? 'App' }`

  const token = cookies.get('token')
  const isAuthenticated = typeof token !== "undefined" && token !== null && token.length > 0
  const routeName = to.name?.toString() ?? ''

  if (!['login', 'sign-up'].includes(routeName) && !isAuthenticated) {
    next({ name: 'login' })
  } else if(['login', 'sign-up'].includes(routeName) && isAuthenticated) {
    next({ name: 'client-home' })
  } else next()
})

export default router
